module.exports = __webpack_public_path__ + "img/app-icon.e4978265.png";